export const GET_EMPLOYEES_LIST = 'GET_EMPLOYEES_LIST';
export const RESET_EMPLOYEES_LIST = 'RESET_EMPLOYEES_LIST';
